module.exports = __webpack_public_path__ + "img/report-10.9d275655.jpg";